import { createAsyncThunk } from '@reduxjs/toolkit'
import { callApi } from '../../utils/callApi'
import { TypeTemplates } from '../../utils/consts'
import { IGroupTemplate, ITemplate, ITemplatesState } from '../templates/types'

export const getUnauthorizedTemplates = createAsyncThunk<ITemplatesState['groups']>(
  'templatesUnauthorized/getUnauthorizedTemplates',
  async (_, thunkAPI) => {
    try {
      return callApi({
        method: 'get',
        path: `/admin-office/templates?is_type=${TypeTemplates.UNAUTHORIZED}`,
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

interface TCreateCroupR {
  name: string
  is_type: TypeTemplates.UNAUTHORIZED
}
export const createGroup = createAsyncThunk<IGroupTemplate, TCreateCroupR>(
  'templatesUnauthorized/createGroup',
  async (payload, thunkAPI) => {
    try {
      const data = payload
      return callApi({
        method: 'post',
        data,
        path: '/admin-office/group',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

interface TUpdateCroupR {
  id: number
  data: {
    name: string
    is_type: TypeTemplates.UNAUTHORIZED
  }
}
export const updateGroup = createAsyncThunk<IGroupTemplate, TUpdateCroupR>(
  'templatesUnauthorized/updateGroup',
  async (payload, thunkAPI) => {
    try {
      const { id, data } = payload
      return callApi({
        method: 'patch',
        data,
        path: `/admin-office/group/${id}`,
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

interface TCreateTemplateR {
  group_id: number
  product_id: number
  message: string
  is_type: TypeTemplates.UNAUTHORIZED
}
export const createTemplate = createAsyncThunk<ITemplate, TCreateTemplateR>(
  'templatesUnauthorized/createTemplate',
  async (payload, thunkAPI) => {
    try {
      const data = payload
      return callApi({
        method: 'post',
        data,
        path: '/admin-office/template',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

interface TUpdateTemplateR {
  id: number
  data: {
    product_id: number
    message: string
    is_type: TypeTemplates.UNAUTHORIZED
  }
}
export const updateTemplate = createAsyncThunk<ITemplate, TUpdateTemplateR>(
  'templatesUnauthorized/updateTemplate',
  async (payload, thunkAPI) => {
    try {
      const { id, data } = payload
      return callApi({
        method: 'patch',
        data,
        path: `/admin-office/template/${id}`,
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const deleteTemplate = createAsyncThunk<ITemplate, number>(
  'templatesUnauthorized/deleteTemplate',
  async (payload, thunkAPI) => {
    try {
      const id = payload
      return callApi({
        method: 'delete',
        data: {},
        path: `/admin-office/template/${id}`,
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)
